import {
  menuEditionStatusFactory,
  ProductEdited,
  ProductMenuEditionStatus,
  ProductMenuValidationStep,
  ProductType,
  SSOLink,
} from '../models';
import { GameData } from './data';

export const creationMode = 'creation';

export class GameEdited<T = unknown> implements ProductEdited<GameDataExtended<T>> {
  slug: string;
  name: string;
  data: GameDataExtended<T>;
  documents?: string[];
  visible?: boolean;
  active?: boolean;
  updatedAt?: Date;
  publishedAt?: Date;
  productType?: ProductType;
  subType?: string; // gameType
  shareInProgress?: boolean;
  threadSlug?: string;
  folderProduct?: { slug: string };
  hasConfigDraft?: boolean;

  constructor(edited?: GameEdited) {
    this.slug = edited?.slug;
    this.name = edited?.name;
    this.data = new GameDataExtended<T>(edited?.data as GameDataExtended<T>);
    this.updatedAt = edited?.updatedAt ? new Date(edited.updatedAt) : null;
    this.visible = edited?.visible ?? false;
    this.active = edited?.active ?? false;
    this.publishedAt = edited?.publishedAt ? new Date(edited.publishedAt) : null;
    this.productType = ProductType.GAME;
    this.subType = edited?.subType;
    this.shareInProgress = edited?.shareInProgress ?? false;
    this.threadSlug = edited?.threadSlug;
    this.folderProduct = edited?.folderProduct;
    this.hasConfigDraft = edited?.hasConfigDraft ?? false;
  }
}

export class GameDataExtended<T = unknown> extends GameData<T> {
  editionInfo: GameEditionInfo;
  constructor(data?: GameDataExtended<T>) {
    super(data);
    this.editionInfo = new GameEditionInfo(data?.editionInfo);
  }
}

export class GameEditionInfo {
  paramsStatus: ProductMenuEditionStatus;
  contentStatus: ProductMenuEditionStatus;
  validationStatus: ProductMenuEditionStatus;
  publicationStatus: ProductMenuEditionStatus;
  ssoLinks: SSOLink[];
  validationStep: ProductMenuValidationStep;

  constructor(info?: GameEditionInfo) {
    this.paramsStatus = menuEditionStatusFactory(info?.paramsStatus ?? ProductMenuEditionStatus.PRISTINE);
    this.contentStatus = menuEditionStatusFactory(info?.contentStatus ?? ProductMenuEditionStatus.PRISTINE);
    this.validationStatus = menuEditionStatusFactory(info?.validationStatus ?? ProductMenuEditionStatus.PRISTINE);
    this.publicationStatus = menuEditionStatusFactory(info?.publicationStatus ?? ProductMenuEditionStatus.PRISTINE);
    this.ssoLinks = (info?.ssoLinks || []).map(l => new SSOLink(l));
    this.validationStep = info?.validationStep || ProductMenuValidationStep.CONDITIONS;
  }
}
